<ng-container matColumnDef="select">
    <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="api.masterToggle()"
            [checked]="api.isChecked()"
            [indeterminate]="api.isIndeterminate()"
            class="header-checkbox"
        >
        </mat-checkbox>
    </mat-header-cell>
    <mat-cell *matCellDef="let row">
        <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="api.selectToggle(row)"
            [checked]="api.modelChecked(row)"
            [disabled]="row.disabled"
            class="cell-checkbox"
        >
        </mat-checkbox>
    </mat-cell>
</ng-container>
